import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {CountryLevelPartnerReportDownloadClientStrategy, CountryLevelPartnerReportDownloadServerStrategy} from './downloadStrategy';
import {CountryLevelPartnerReportService} from './service';
import {CountryLevelPartnerReportServiceTypes, type CountryLevelPartnerReportViewModelKeys} from './types';

export class CountryLevelPartnerReportContainerFacade extends ContainerFacade {
    bindAll() {
        this._container
            .bind<IEntityReadService<EntityType>>(CountryLevelPartnerReportServiceTypes.service)
            .to(CountryLevelPartnerReportService);
        this._container
            .bind<IDownloadStrategy<CountryLevelPartnerReportViewModelKeys>>(CountryLevelPartnerReportServiceTypes.downloadClientStrategy)
            .to(CountryLevelPartnerReportDownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<CountryLevelPartnerReportViewModelKeys>>(CountryLevelPartnerReportServiceTypes.downloadServerStrategy)
            .to(CountryLevelPartnerReportDownloadServerStrategy);
    }
}
